var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFileDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#12376B",
    points: "44,27 4,27 1,23 5,19 43,19 47,23 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l24,0l12,12v32C43,46.105,42.105,47,41,47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M31,1v10c0,1.105,0.895,2,2,2h10L31,1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27549B",
    d: "M45,41H3c-1.105,0-2-0.895-2-2V23h46v16C47,40.105,46.105,41,45,41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.525,31.907c0,1.311-0.36,2.32-1.082,3.029C17.723,35.646,16.708,36,15.4,36h-2.54v-7.853h2.718 c1.26,0,2.233,0.322,2.919,0.967C19.184,29.759,19.525,30.689,19.525,31.907z M17.324,31.982c0-0.72-0.143-1.253-0.428-1.601 c-0.284-0.348-0.717-0.521-1.297-0.521h-0.617v4.398h0.473c0.645,0,1.117-0.188,1.418-0.562S17.324,32.752,17.324,31.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.281,32.062c0,1.322-0.324,2.326-0.973,3.014s-1.598,1.031-2.847,1.031c-1.231,0-2.177-0.346-2.833-1.037 c-0.657-0.69-0.986-1.697-0.986-3.018c0-1.308,0.327-2.306,0.98-2.995c0.654-0.689,1.604-1.034,2.85-1.034 c1.25,0,2.197,0.343,2.842,1.026S28.281,30.738,28.281,32.062z M22.877,32.062c0,1.519,0.529,2.277,1.585,2.277 c0.537,0,0.936-0.184,1.194-0.553c0.26-0.369,0.391-0.943,0.391-1.725c0-0.783-0.133-1.363-0.395-1.737 c-0.264-0.374-0.656-0.562-1.18-0.562C23.409,29.764,22.877,30.53,22.877,32.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M33.195,29.775c-0.505,0-0.898,0.206-1.182,0.62c-0.283,0.413-0.424,0.983-0.424,1.71 c0,1.512,0.574,2.268,1.724,2.268c0.347,0,0.685-0.049,1.01-0.146s0.653-0.213,0.983-0.349v1.793 c-0.656,0.291-1.396,0.436-2.225,0.436c-1.185,0-2.094-0.344-2.725-1.031c-0.633-0.688-0.949-1.682-0.949-2.98 c0-0.813,0.154-1.527,0.459-2.144c0.307-0.616,0.748-1.09,1.322-1.421s1.25-0.496,2.027-0.496c0.849,0,1.66,0.184,2.434,0.553 L35,30.258c-0.29-0.136-0.58-0.25-0.87-0.344C33.84,29.821,33.528,29.775,33.195,29.775z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileDoc);
export default __webpack_public_path__ + "static/media/icon-file-doc.f6591412b4fcfaf4e675d45780c4d365.svg";
export { ForwardRef as ReactComponent };